import { apiClient } from './api/apiClient';
import type { ApiResponse } from '../types';

export interface DashboardStats {
  shiftsToday: number;
  shiftsInProgress: number;
  hoursWorkedThisMonth: number;
  pendingRequests: number;
  unreadNotifications: number;
  activeEmployees: number;
  totalSites: number;
}

export interface SiteDashboard {
  siteId: number;
  siteName: string;
  city: string;
  isActive: boolean;
  shiftsToday: number;
  shiftsInProgress: number;
  activeEmployees: number;
  pendingRequests: number;
  hoursWorkedThisMonth: number;
  managerName?: string;
}

export interface CompanyDashboard {
  totals: DashboardStats;
  sites: SiteDashboard[];
}

export const dashboardService = {
  getStats: async (): Promise<DashboardStats> => {
    const response = await apiClient.get<ApiResponse<DashboardStats>>('/dashboard');
    return response.data!;
  },

  getCompanyDashboard: async (): Promise<CompanyDashboard> => {
    const response = await apiClient.get<ApiResponse<CompanyDashboard>>('/dashboard/company');
    return response.data!;
  },

  getSiteDashboard: async (siteId: number): Promise<SiteDashboard> => {
    const response = await apiClient.get<ApiResponse<SiteDashboard>>(`/dashboard/site/${siteId}`);
    return response.data!;
  },
};
